//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'TooltipAjuda',
  props: {
    mensagem: String,
    color: {
      type: String,
      default: 'white',
    },
  },
};



// WEBPACK FOOTER //
// ./src/shared-components/TooltipAjuda.vue?vue&type=script&lang=js&